import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tab';
import { TEST_IDS } from 'mocks/ids';
import { useCreateReferenceMutation } from 'modules/threads/threadsApi';
import { ICreateReferenceMutation } from 'modules/threads/types';
import { showErrorMessage, showSuccessMessage } from 'modules/alert/utils';
import { useModal } from 'modules/modals/ModalProvider';
import { File, FolderOpen, Link } from 'lucide-react';
import { FileForm } from './forms/file-form';
import { LinkForm } from './forms/link-form';
import { MultiFileForm } from './forms/multifile-form';

export const AddReferenceModal = ({ threadId }: { threadId: string }) => {
  const { close } = useModal();
  const [createReference, { isLoading }] = useCreateReferenceMutation();
  const onSubmit = async (payload: Omit<ICreateReferenceMutation, 'thread'>) => {
    try {
      await createReference({ thread: threadId, ...payload }).unwrap();
      showSuccessMessage('Reference created successfully');
      close();
    } catch (err) {
      console.error(err);
      showErrorMessage('An error occured when creating the reference');
    }
  };
  return (
    <div data-testid={TEST_IDS.add_reference_modal} className="h-[calc(100%-24px)] w-full">
      <Tabs defaultValue="file" className="h-full w-full">
        <TabsList className="w-full cursor-pointer">
          <TabsTrigger className="w-1/3" value="file" aria-label="File">
            <File className="mr-2 h-4 w-4" /> File
          </TabsTrigger>
          <TabsTrigger className="w-1/3" value="link" aria-label="Link">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link className="mr-2 h-4 w-4" /> Link
          </TabsTrigger>
          <TabsTrigger className="w-1/3" value="multifile" aria-label="Multiple Files">
            <FolderOpen className="mr-2 h-4 w-4" /> Multiple Files
          </TabsTrigger>
        </TabsList>
        <div className="h-full overflow-auto">
          <TabsContent value="file">
            <FileForm onSubmit={onSubmit} isSubmitting={isLoading} threadId={threadId} />
          </TabsContent>
          <TabsContent value="link">
            <LinkForm onSubmit={onSubmit} isSubmitting={isLoading} />
          </TabsContent>
          <TabsContent value="multifile">
            <MultiFileForm threadId={threadId} />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
